const readMoreSections = document.querySelectorAll(".read-more__text");
readMoreSections.forEach((section) => {
  const wrapper = section.parentNode;
  const readMoreButton = wrapper.querySelector(".read-more");

  if (readMoreButton) {
    readMoreButton.addEventListener("click", function () {
      section.classList.toggle("show-more");
      if (section.classList.contains("show-more")) {
        readMoreButton.textContent = "Weniger lesen";
      } else {
        readMoreButton.textContent = "Mehr lesen";
      }
    });
  }
});

const counter = document.querySelector(".counter__value");
if (counter) {
  const options = {
    root: null,
    rootMargin: "0px",
    threshold: 0.8,
  };

  function handleIntersection(entries, observer) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        runCounter();
        observer.disconnect();
      }
    });
  }

  new IntersectionObserver(handleIntersection, options).observe(counter);

  let currentCount = 0;
  let targetCount = counter.dataset.target;
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  let step = 1;
  let stepTime = 0.1;

  async function runCounter() {
    while (currentCount < targetCount) {
      currentCount += step;
      counter.textContent = currentCount
        .toLocaleString("en-US")
        .replaceAll(",", ".");
      const percentageCounted = (currentCount / targetCount) * 100;
      if (percentageCounted < 30) {
        step = 10;
        stepTime = 1;
      } else if (percentageCounted < 60) {
        step = 5;
        stepTime = 1;
      } else if (percentageCounted < 95) {
        step = 5;
        stepTime = 2;
      } else if (percentageCounted < 99) {
        step = 1;
        stepTime = 5;
      } else {
        stepTime = 100;
      }
      await sleep(stepTime);
    }
  }

  const counterInfo = document.querySelector(".counter__info");
  const counterInfoPopup = document.querySelector(".counter__info-popup");

  if (counterInfoPopup) {
    counterInfo.addEventListener("click", function () {
      counterInfoPopup.classList.add("show");
    });
    document
      .querySelector(".counter__info-close")
      .addEventListener("click", function (e) {
        counterInfoPopup.classList.remove("show");
      });
  }
}

class B2BSelect extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.options = this.querySelectorAll("[data-index]");
    this.chosenValue = this.querySelector("[data-chosen-value]");
    this.options.forEach((option) => {
      option.addEventListener("click", () => {
        this.chosenValue.textContent = option.textContent;
        this.classList.remove("show");
        this.dispatchEvent(
          new CustomEvent("change", {
            detail: {
              index: option.dataset.index,
            },
            bubbles: true,
          })
        );
      });
    });

    this.chosenValue.addEventListener("click", () => {
      this.classList.toggle("show");
    });
  }
}

if (!customElements.get("b2b-select")) {
  customElements.define("b2b-select", B2BSelect);
}

class B2BGroup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.priceCell = this.querySelector("[data-price-cell]");
    this.priceCellRows = Array.from(
      this.priceCell.querySelectorAll("[data-index]")
    );
    this.addEventListener("change", (e) => {
      this.priceCellRows.forEach((row) => row.classList.add("hidden"));
      this.priceCellRows
        .find((row) => row.dataset.index === e.detail.index)
        .classList.remove("hidden");
    });
  }
}

if (!customElements.get("b2b-group")) {
  customElements.define("b2b-group", B2BGroup);
}

class B2BPassword extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.password = this.dataset.password;
    this.init();
  }

  init() {
    this.passwordInput = this.querySelector("input");
    this.button = this.querySelector("[data-submit]");
    this.button.addEventListener("click", () => {
      if (this.passwordInput.value === this.password) {
        console.log("Passwort korrekt");
        this.remove();
      }
      else {
        alert("Falsches Passwort");
      }
    });
  }
}

if (!customElements.get("b2b-password")) {
  customElements.define("b2b-password", B2BPassword);
}

class B2BOrderForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.emptyMessage = this.dataset.emptyMessage;
    this.errorMessage = this.dataset.errorMessage;
    this.init();
  }

  init() {
    this.form = this.closest("form");
    this.button = this.querySelector("[type=submit]");
    this.success = this.querySelector("[data-success]");
    this.quantityInputs = Array.from(this.querySelectorAll("[data-quantity]"));
    this.form.addEventListener("submit", (e) => this.onSubmit(e));

    // Quantities are numbers only, whether typed or pasted
    this.quantityInputs.forEach((input) => {
      input.addEventListener("input", () => {
        input.value = input.value.replace(/\D/g, "");
      });
    });
  }

  // Posted in the background so the customer stays on the page
  async onSubmit(e) {
    e.preventDefault();

    const order = new FormData(this.form);
    let total = 0;

    this.quantityInputs.forEach((input) => {
      const quantity = parseInt(input.value, 10);

      if (quantity) {
        total += quantity;
      } else {
        order.delete(input.name);
      }
    });

    if (!total) {
      alert(this.emptyMessage);
      return;
    }

    this.button.disabled = true;

    const response = await fetch(this.form.action, {
      method: "POST",
      headers: { Accept: "application/json" },
      body: new URLSearchParams(order),
    });

    this.button.disabled = false;

    if (response.ok) {
      this.form.reset();
      this.success.classList.remove("hidden");
      this.success.scrollIntoView({ behavior: "smooth", block: "center" });
    } else {
      alert(this.errorMessage);
    }
  }
}

if (!customElements.get("b2b-order-form")) {
  customElements.define("b2b-order-form", B2BOrderForm);
}


// Clean up stray " --> " text leaked by an app embed below the footer
(function cleanupStrayArrow() {
  function removeStrayArrows() {
    document.querySelectorAll('body > *').forEach(function(el) {
      var t = el.textContent.trim();
      if (t === '-->' || t === '--> ') {
        el.remove();
      }
    });
    Array.from(document.body.childNodes).forEach(function(node) {
      if (node.nodeType === Node.TEXT_NODE) {
        var t = node.textContent.trim();
        if (t === '-->' || t === '--> ') {
          node.remove();
        }
      }
    });
  }

  // Run immediately
  removeStrayArrows();

  // Also watch for late injections
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType === Node.ELEMENT_NODE) {
          var t = node.textContent.trim();
          if (t === '-->' || t === '--> ') {
            node.remove();
          }
        } else if (node.nodeType === Node.TEXT_NODE) {
          var t = node.textContent.trim();
          if (t === '-->' || t === '--> ') {
            node.remove();
          }
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();